/* LH | Set picker ("Mengenliste", Leon 24.10.2026). Config and rules: snippets/lh-set-picker.liquid.
 *
 * Rules and reasons (plain English):
 * - Same idea as the 2-pack set switch (assets/lh-set-switch.js), for 1 to n pieces: a row click clicks the label of
 *   the matching TeeInBlue "Verfügbare Produkte" radio, exactly like a customer would. TeeInBlue then loads the set's
 *   print area and price, keeps the personalisation and adds the set variant with its print file itself.
 * - Which radio is which: the radio label equals an option value of the row's variant ("Einzeln", "2er-Set", ...)
 *   that no other row shares. A row without its radio is hidden; with fewer than two usable rows the block stays
 *   hidden and the TeeInBlue radio is left alone.
 * - The selected row is read from TeeInBlue's active radio, never stored separately, so both can never disagree.
 * - The single is always preselected (Leon 25.10.2026); only a ?variant= link may open on a set.
 * - The TeeInBlue radio group is hidden while the picker serves the product. Radios without a row (5er, 6er) can
 *   therefore not be picked on the page.
 * - Placement: inside the TeeInBlue form, directly above the first add-on field (a field with priced tiles,
 *   .ck-has-addon-price from teeinblue-custom.js, e.g. LED tealight). Without such a field: at the end of the form.
 * - Addon mode (config.mode = "addon"): after TeeInBlue added the set line we add the placeholder variant of that
 *   row with _partner_of = the set line's _customization_id, same pattern as lh-set-switch.js. While that runs,
 *   window.__lhSetAddonPending tells the cart rules (assets/lh-partner-upsell-cart.js) to wait.
 * - LED tealight and gift box are TeeInBlue fields on the artwork (Leon 25.10.2026: extras always through TeeInBlue,
 *   linked by customization ids, so Printlabs gets them as extras of the main item). Gift box: colour first ("Keine",
 *   "Rosa", "Blau"), the count field of that colour opens by a TeeInBlue condition. The script caps the counts (option
 *   ids starting with a prefix in config.cap) at the picked pieces and draws the gift box like the print file check
 *   (variant B, below).
 *   Info icons on those fields come from snippets/lh-addon-info.liquid.
 */
(function () {
  if (window.__lhSpLoaded) return;
  window.__lhSpLoaded = true;

  var busy = false;
  var fellBack = false;
  var singleChecked = false;
  // Did the customer arrive on a ?variant= link? Read the URL of the page request itself: TeeInBlue and the theme
  // write ?variant=<default> into the address bar on load, so location.search cannot tell.
  var variantLink = (function () {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      return /[?&]variant=/.test(new URL(nav ? nav.name : location.href).search);
    } catch (e) { return /[?&]variant=/.test(location.search); }
  })();

  function root() { return document.querySelector('[data-lh-sp]'); }

  var config = null;
  function cfg() {
    if (config) return config;
    var el = document.querySelector('[data-lh-sp-config]');
    try { config = el ? JSON.parse(el.textContent) : null; } catch (e) { config = null; }
    // texts come through Liquid's t filter, which HTML escapes them ("d&#39;abord"); the script sets textContent
    if (config && config.t) Object.keys(config.t).forEach(function (k) {
      var d = document.createElement('textarea');
      d.innerHTML = config.t[k];
      config.t[k] = d.value;
    });
    return config;
  }

  function norm(s) { return String(s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function field() { return document.querySelector('#tee-field--teeinblue-available-prod'); }

  function hideTarget() {
    var f = field();
    if (!f) return null;
    var block = f.closest('.tee-available-products');
    if (block && block.querySelectorAll('input').length === f.querySelectorAll('input').length) return block;
    return f;
  }

  // { <n>: radio wrapper } for every row whose radio was found
  function radios() {
    var c = cfg();
    var f = field();
    if (!c || !f) return null;
    var wraps = Array.prototype.filter.call(f.querySelectorAll('.tee-radio'), function (w) {
      return w.querySelector('input[id^="teeinblue-available-prod-"]');
    });
    var count = {};
    // Count each value once per row: candle cube variants repeat it ("Einzel / Einzel / 7 x 7 x 7 cm")
    c.rows.forEach(function (r) {
      (r.options || []).map(norm).filter(function (o, i, a) { return a.indexOf(o) === i; }).forEach(function (o) { count[o] = (count[o] || 0) + 1; });
    });
    var out = {};
    var found = 0;
    wraps.forEach(function (w) {
      var label = w.querySelector('label');
      var text = norm(label && label.textContent);
      if (!text || count[text] !== 1) return; // a value two rows share (e.g. "Glas") cannot tell them apart
      c.rows.forEach(function (r) {
        if ((r.options || []).map(norm).indexOf(text) !== -1) { out[r.n] = w; found++; }
      });
    });
    return found >= 2 ? out : null;
  }

  function activeN(r) {
    if (!r) return 0;
    for (var n in r) { if (r[n].classList.contains('active')) return Number(n); }
    return 0;
  }

  function row(n) { return cfg().rows.find(function (x) { return x.n === n; }); }

  function setAttr(el, k, v) { if (el && el.getAttribute(k) !== v) el.setAttribute(k, v); }

  function anchor() {
    var form = document.querySelector('.tee-customization-form');
    if (!form) return null;
    var tile = form.querySelector('.ck-has-addon-price');
    var f = tile && tile.closest('.tee-field');
    return f && f.parentElement === form ? { before: f } : { into: form };
  }

  function update() {
    var el = root();
    if (!el) return;
    // One piece only (line without set SKUs, e.g. the "Mama" candle cubes, every tealight without the picker tag): no
    // list, only the gift box block. A product that still sells sets through the TeeInBlue radios (Unser Tag 2er-Set)
    // gets as many boxes as the picked radio says ("2er-Set", "Set van 2", "Lot de 2" = 2), else 1 (Leon 28.10.2026).
    var c0 = cfg();
    if (c0 && c0.rows.length === 1) {
      if (!el.classList.contains('lh-sp-hidden')) el.classList.add('lh-sp-hidden');
      var f1 = field();
      var on = f1 && f1.querySelector('.tee-radio.active');
      var m = on && /(\d+)/.exec(on.textContent || '');
      var n = m ? Number(m[1]) : 1;
      applyCap(n);
      boxCard(n);
      return;
    }
    var r = radios();
    var f = hideTarget();
    if (!r) {
      if (!el.classList.contains('lh-sp-hidden')) el.classList.add('lh-sp-hidden');
      if (f && f.dataset.lhSpHidden) { f.style.display = ''; delete f.dataset.lhSpHidden; }
      return;
    }
    var a = anchor();
    // "Extras wählen" sits between the picker and the first add-on field (LED), so the add-ons read as their own step
    var ex = extrasLabel(a);
    var next = ex || (a && a.before);
    if (next && el.nextElementSibling !== next) next.insertAdjacentElement('beforebegin', el);
    if (a && a.into && el.parentElement !== a.into) a.into.appendChild(el);
    if (f && f.style.display !== 'none') { f.style.display = 'none'; f.dataset.lhSpHidden = '1'; }
    if (el.classList.contains('lh-sp-hidden')) el.classList.remove('lh-sp-hidden');

    var act = activeN(r);
    // The single is always preselected (Leon 25.10.2026): a product whose first Shopify variant is a set (e.g. the NL
    // wine glass) opens on that set, so the single is picked once per page load. A ?variant= link stays as it is.
    if (!busy && !singleChecked) {
      singleChecked = true;
      if (act > 1 && !variantLink) { pick(1); return; }
    }
    // A link to a variant without a row (?variant=<5er-Set>, e.g. from a shopping feed): TeeInBlue sits on a set the
    // customer cannot see, so the single is selected once instead (no row checked would hide a 69,95 € set).
    if (!act && !busy && !fellBack) {
      var f0 = field();
      var stray = f0 && f0.querySelector('.tee-radio.active');
      if (stray) { fellBack = true; pick(1); return; }
    }
    el.querySelectorAll('[data-lh-sp-row]').forEach(function (b) {
      var n = Number(b.getAttribute('data-lh-sp-row'));
      var has = !!r[n];
      if (b.hidden === has) b.hidden = !has;
      if (!busy) setAttr(b, 'aria-checked', n === act ? 'true' : 'false');
    });
    applyCap(act || 1);
    boxCard(act || 1);
    queueThumbs();
  }

  function extrasLabel(a) {
    var c = cfg();
    var lbl = document.querySelector('[data-lh-sp-extras]');
    if (!a || !a.before || !c || !c.t || !c.t.extras) { if (lbl) lbl.hidden = true; return null; }
    if (!lbl) {
      lbl = document.createElement('div');
      lbl.className = 'lh-sp-extras';
      lbl.setAttribute('data-lh-sp-extras', '');
      var pill = document.createElement('span');
      pill.className = 'lh-sp__step';
      pill.textContent = c.t.extras;
      lbl.appendChild(pill);
    }
    if (lbl.hidden) lbl.hidden = false;
    if (lbl.nextElementSibling !== a.before) a.before.insertAdjacentElement('beforebegin', lbl);
    return lbl;
  }

  function track(name, n) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, lh_upsell: 'set_picker', lh_set_pieces: n });
    } catch (e) {}
  }

  function pick(n) {
    var r = radios();
    if (!r || !r[n] || busy || activeN(r) === n) return;
    var label = r[n].querySelector('label');
    if (!label) return;
    busy = true;
    var el = root();
    var btn = el.querySelector('[data-lh-sp-row="' + n + '"]');
    el.querySelectorAll('[data-lh-sp-row]').forEach(function (b) { setAttr(b, 'aria-checked', b === btn ? 'true' : 'false'); }); // instant feedback
    setAttr(btn, 'aria-busy', 'true');
    label.click();
    track('lh_set_pick', n);
    // TeeInBlue switches the base product asynchronously; check that it followed
    var tries = 0;
    (function check() {
      var now = radios();
      if ((now && activeN(now) === n) || tries++ > 40) {
        if (tries > 40) console.warn('[LH Set picker] TeeInBlue did not switch the product');
        busy = false;
        if (btn) btn.removeAttribute('aria-busy');
        update();
        return;
      }
      setTimeout(check, 100);
    })();
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-lh-sp-row]');
    var el = root();
    if (!t || !el || !el.contains(t)) return;
    e.preventDefault();
    pick(Number(t.getAttribute('data-lh-sp-row')));
  });

  /* ---------- live thumbnails: the customer's own design in every row (as lh-set-switch.js does on its card) ----------
   * Clone TeeInBlue's live preview (.tee-mockup) into each row thumb, scaled to cover it. Until it is there the product
   * photo stays. Re-done when the preview changes (names, figures) via the mutation observer below. */
  var thumbKey = null, thumbTimer = null;
  function syncThumbs() {
    var src = document.querySelector('#tee-gallery .tee-mockup-item--loaded .tee-mockup');
    var boxes = document.querySelectorAll('[data-lh-sp-thumb]');
    if (!src || !boxes.length || !src.offsetWidth || !src.offsetHeight || !boxes[0].clientWidth) return;
    var bw = boxes[0].clientWidth, bh = boxes[0].clientHeight;
    var scale = Math.max(bw / src.offsetWidth, bh / src.offsetHeight);
    var key = scale + '|' + src.innerHTML;
    if (key === thumbKey && boxes[0].querySelector('.lh-sp__live')) return;
    thumbKey = key;
    boxes.forEach(function (box) {
      var clone = src.cloneNode(true);
      clone.querySelectorAll('[id]').forEach(function (e) { e.removeAttribute('id'); });
      clone.style.position = 'absolute';
      clone.style.left = ((bw - src.offsetWidth * scale) / 2) + 'px';
      clone.style.top = ((bh - src.offsetHeight * scale) / 2) + 'px';
      clone.style.transformOrigin = '0 0';
      clone.style.transform = 'scale(' + scale + ')';
      clone.style.pointerEvents = 'none';
      var live = box.querySelector('.lh-sp__live');
      if (!live) {
        live = document.createElement('span');
        live.className = 'lh-sp__live';
        box.appendChild(live);
      }
      live.replaceChildren(clone);
      box.classList.add('lh-sp__thumb--live');
    });
  }
  function queueThumbs() {
    clearTimeout(thumbTimer);
    thumbTimer = setTimeout(syncThumbs, 250);
  }

  /* ---------- cap the gift box count at the picked pieces (Leon 25.10.2026) ----------
   * config.cap = option id prefixes (e.g. "box-"). Every TeeInBlue choice whose value starts with one and ends in a count
   * ("box-rosa-3") is a count tile: tiles above the picked pieces are hidden with their whole grid column (else the
   * empty columns push the next tiles into a second row), and a choice above it drops to the same field at the picked
   * count. The colour chooser ("box-rosa") has no count and is never touched. LED is not capped (Leon: LED is free). */
  function optCount(input) { var m = /-(\d+)$/.exec(input.value || ''); return m ? Number(m[1]) : 0; }
  function capInputs(c) {
    var sel = c.cap.map(function (p) { return '.tee-customization-form input[value^="' + p.replace(/"/g, '') + '"]'; }).join(',');
    return Array.prototype.filter.call(document.querySelectorAll(sel), function (i) { return optCount(i) > 0; });
  }
  function applyCap(pieces) {
    var c = cfg();
    if (!c || !c.cap || !c.cap.length || !pieces) return;
    var byName = {};
    capInputs(c).forEach(function (i) {
      (byName[i.name] = byName[i.name] || []).push(i);
      var tile = i.closest('.tee-clipart-col') || i.parentElement;
      var over = optCount(i) > pieces;
      if (tile && tile.classList.contains('lh-sp-capped') !== over) tile.classList.toggle('lh-sp-capped', over);
    });
    Object.keys(byName).forEach(function (name) {
      var list = byName[name];
      var on = list.find(function (i) { return i.checked; });
      if (!on || optCount(on) <= pieces) return;
      var want = on.value.replace(/-\d+$/, '-' + pieces);
      var to = list.find(function (i) { return i.value === want; }) || list.find(function (i) { return optCount(i) === 1; });
      var label = to && to.parentElement && to.parentElement.querySelector('label');
      if (label) label.click(); else if (to) to.click();
    });
  }

  /* ---------- gift box in the look of the print file check, variant B (Leon 25.10.2026) ----------
   * The TeeInBlue fields stay the source of truth (they add and link the box lines) and are hidden; the theme draws:
   * heading "Geschenkverpackung", two options like "Druckdatei-Prüfung" (same ck-datacheck__ classes: "Keine
   * Verpackung 0,00€" preselected, "Mit Geschenkverpackung (i) ab 3,95€"), then colour tiles and "Wie viele Boxen?"
   * with 1 to the picked pieces, ALWAYS there (nothing may pop in) and pale until "Mit" is picked.
   * Colour field = a field whose choices all start with a config.cap prefix and carry no count ("box-rosa"); count
   * fields = the same with a count ("box-rosa-3"), one per colour, opened by a TeeInBlue condition. "Mit" without a
   * colour picks the first colour; a colour or count click picks "Mit"; a colour change keeps the count. */
  var boxLast = { colour: null, n: 1 };
  // The customer's box choice (colour value) while "Mit" is on. Changing the number of persons swaps the TeeInBlue
  // template, which resets the box fields to "Keine" (QA 26.10.2026, FR); the choice is then put back.
  var boxWant = null;
  var boxRestoredAt = 0;
  function boxFields(c) {
    var out = { colour: null, counts: [] };
    document.querySelectorAll('.tee-customization-form .tee-field').forEach(function (f) {
      var ins = f.querySelectorAll(':scope > .tee-field__input input[type="radio"]');
      if (!ins.length) return;
      var all = Array.prototype.every.call(ins, function (i) { return c.cap.some(function (p) { return i.value.indexOf(p) === 0; }); });
      if (!all) return;
      if (Array.prototype.some.call(ins, function (i) { return optCount(i) > 0; })) out.counts.push(f);
      else if (!out.colour) out.colour = f;
    });
    return out;
  }
  function isNoneInput(i) { return !!(i && (/-(keine|none)$/.test(i.value) || (i.parentElement && i.parentElement.classList.contains('ck-none-tile')))); }
  // Same money format as the add-on tiles (assets/teeinblue-custom.js): page language and market currency ("19,00 zł",
  // "39,00 kr", "3,95€"); EUR without the space, as the shop writes it.
  function money(cents) {
    var shop = typeof window.lhMoney === 'function' ? window.lhMoney(cents) : null; // the market's Liquid money format
    if (shop) return shop;
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    var lang = (document.documentElement.lang || 'de').slice(0, 2);
    try {
      var out = new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100);
      return cur === 'EUR' ? out.replace(/\s/g, '') : out;
    } catch (e) { return ''; }
  }
  // Box prices from the product's add-on variants by POSITION, not by name: colour i of the TeeInBlue field = the i-th
  // first option value of the box product (Rosa, Blau), count n = the variant whose second option starts with n.
  // Names differ per language (TeeInBlue "Rose", storefront "Rosa"), positions do not.
  function boxCents(idx, n) {
    var list = ((window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || []).filter(function (x) { return /^\d/.test(String(x.option2 || '')); });
    var cols = [];
    list.forEach(function (x) { if (cols.indexOf(x.option1) === -1) cols.push(x.option1); });
    var v = list.find(function (x) { return x.option1 === cols[idx] && parseInt(x.option2, 10) === n; });
    return v ? v.price : null;
  }
  function labelOf(i) { var l = i && i.parentElement && i.parentElement.querySelector('label'); return l; }
  function boxState(c) {
    var b = boxFields(c);
    if (!b.colour) return null;
    var colours = [];
    var none = null;
    b.colour.querySelectorAll(':scope > .tee-field__input input[type="radio"]').forEach(function (i) {
      if (isNoneInput(i)) { none = i; return; }
      var l = labelOf(i);
      var img = l && l.querySelector('img');
      colours.push({ input: i, value: i.value, name: (l && l.getAttribute('data-title')) || '', img: img ? img.getAttribute('src') : '' });
    });
    var on = b.colour.querySelector('input:checked');
    var colour = on && !isNoneInput(on) ? colours.find(function (x) { return x.input === on; }) : null;
    var countField = colour ? b.counts.find(function (f) { return f.querySelector('input[value^="' + colour.value + '-"]'); }) : null;
    var countOn = countField && countField.querySelector('input:checked');
    return { b: b, none: none, colours: colours, colour: colour, idx: colour ? colours.indexOf(colour) : 0, countField: countField, n: countOn ? optCount(countOn) : 0 };
  }
  function clickInput(i) { var l = labelOf(i); if (l) l.click(); else if (i) i.click(); }
  function clickCount(st, n) {
    clickInput(st.countField && st.countField.querySelector('input[value="' + st.colour.value + '-' + n + '"]'));
  }
  var GIFT_ICON = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="3" y="8" width="18" height="13" rx="2"/><path d="M3 12h18M12 8v13M12 8c-1.5-3-5-4-5-1.5S10 8 12 8zM12 8c1.5-3 5-4 5-1.5S14 8 12 8z"/></svg>';
  function giftBuild(t, pid) {
    var g = document.createElement('div');
    g.className = 'lh-gift';
    g.setAttribute('data-lh-gift', '');
    g.innerHTML =
      '<div class="ck-datacheck__label"><span class="lh-gift__icon">' + GIFT_ICON + '</span><strong data-t="head"></strong></div>' +
      '<div class="ck-datacheck__options">' +
        '<label class="ck-datacheck__option"><input type="radio" name="lh_gift_option" value="none" checked><span class="ck-datacheck__content"><span class="ck-datacheck__title" data-t="none"></span><span class="ck-datacheck__price" data-t="zero"></span></span></label>' +
        '<label class="ck-datacheck__option"><input type="radio" name="lh_gift_option" value="with"><span class="ck-datacheck__content"><span class="ck-datacheck__title"><span data-t="with"></span><button type="button" class="lh-addon-info" data-lh-addon-info="' + pid + '"></button></span><span class="ck-datacheck__price" data-t="from"></span></span></label>' +
      '</div>' +
      '<div class="lh-gift__pick" data-lh-gift-pick>' +
        '<span class="lh-gift__sh" data-t="colour"></span><div class="lh-gift__colours" role="radiogroup" data-lh-gift-colours></div>' +
        '<span class="lh-gift__sh" data-t="qty"></span><div class="lh-gift__qty" role="radiogroup" data-lh-box-qty></div>' +
        '<span class="lh-gift__hint" data-lh-box-hint></span>' +
      '</div>';
    var txt = { head: t.giftHead, none: t.giftNone, zero: money(0), with: t.giftWith, from: t.giftFrom, colour: t.giftColour, qty: t.boxQty };
    g.querySelectorAll('[data-t]').forEach(function (n) { n.textContent = txt[n.getAttribute('data-t')] || ''; });
    var info = g.querySelector('.lh-addon-info');
    if (info) info.setAttribute('aria-label', (t.giftHead || '') + ': Info');
    return g;
  }
  function boxCard(pieces) {
    var c = cfg();
    if (!c || !c.cap || !c.cap.length) return;
    var st = boxState(c);
    var g = document.querySelector('[data-lh-gift]');
    if (!st) { if (g) g.hidden = true; return; }
    var t = c.t || {};
    [st.b.colour].concat(st.b.counts).forEach(function (x) { if (!x.classList.contains('lh-box-hidden')) x.classList.add('lh-box-hidden'); });
    if (boxWant && !st.colour && Date.now() - boxRestoredAt > 1500) {
      var back = st.colours.find(function (x) { return x.value === boxWant; }) || st.colours[0];
      if (back) { boxRestoredAt = Date.now(); clickInput(back.input); return; }
    }
    // a colour change keeps the count the customer picked before (TeeInBlue opens the new colour on 1)
    var colourId = st.colour ? st.colour.value : null;
    if (colourId && colourId !== boxLast.colour && st.countField && boxLast.n > 1) {
      var want = Math.min(boxLast.n, pieces);
      boxLast.colour = colourId;
      if (st.n !== want) { clickCount(st, want); return; }
    }
    boxLast.colour = colourId;
    if (colourId && st.n) boxLast.n = st.n;
    if (!g) {
      var pid = '';
      var first = ((window.teeinblueCampaign && window.teeinblueCampaign.addonVariants) || []).find(function (v) { return /^\d/.test(String(v.option2 || '')); });
      if (first && first.featured_image && first.featured_image.product_id) pid = String(first.featured_image.product_id);
      g = giftBuild(t, pid || (t.giftInfo || ''));
    }
    var last = st.b.counts.length ? st.b.counts[st.b.counts.length - 1] : st.b.colour;
    if (last.compareDocumentPosition(st.b.colour) & Node.DOCUMENT_POSITION_FOLLOWING) last = st.b.colour;
    if (last.nextElementSibling !== g) last.insertAdjacentElement('afterend', g);
    if (g.hidden) g.hidden = false;
    var live = !!colourId;
    var radios = g.querySelectorAll('input[name="lh_gift_option"]');
    if (radios[0].checked === live) radios[0].checked = !live;
    if (radios[1].checked !== live) radios[1].checked = live;
    var from = boxCents(st.idx, 1);
    // "ab 3,95€" only when there is a choice of counts; one piece = one box, so its price
    var fromTxt = from == null ? '' : pieces <= 1 ? money(from) : (t.giftFrom || '__P__').replace('__P__', money(from));
    var fromEl = g.querySelector('[data-t="from"]');
    if (fromEl.textContent !== fromTxt) fromEl.textContent = fromTxt;
    var pick = g.querySelector('[data-lh-gift-pick]');
    pick.classList.toggle('lh-gift__pick--off', !live);
    var cbox = g.querySelector('[data-lh-gift-colours]');
    if (cbox.childElementCount !== st.colours.length) {
      cbox.replaceChildren();
      st.colours.forEach(function (x) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'lh-gift__c';
        btn.setAttribute('role', 'radio');
        btn.setAttribute('data-lh-gift-colour', x.value);
        btn.innerHTML = '<span class="lh-gift__ci"><img alt="" width="56" height="56"></span><span class="lh-gift__cn"></span>';
        btn.querySelector('.lh-gift__cn').textContent = x.name;
        cbox.appendChild(btn);
      });
    }
    st.colours.forEach(function (x) {
      var btn = cbox.querySelector('[data-lh-gift-colour="' + x.value + '"]');
      if (!btn) return;
      setAttr(btn, 'aria-checked', live && x.value === colourId ? 'true' : 'false');
      var img = btn.querySelector('img');
      if (x.img && img.getAttribute('src') !== x.img) img.setAttribute('src', x.img);
    });
    var row = g.querySelector('[data-lh-box-qty]');
    var key = [pieces, colourId, st.n, st.idx].join('|');
    if (row.getAttribute('data-key') !== key) {
      row.setAttribute('data-key', key);
      row.replaceChildren();
      for (var k = 1; k <= pieces; k++) {
        var q = document.createElement('button');
        q.type = 'button';
        q.className = 'lh-gift__q';
        q.setAttribute('role', 'radio');
        q.setAttribute('data-lh-box-n', String(k));
        q.setAttribute('aria-checked', live && k === st.n ? 'true' : 'false');
        var l1 = document.createElement('b');
        l1.textContent = k === 1 ? (t.boxOne || '1') : (t.boxMany || '__N__').replace('__N__', k);
        var l2 = document.createElement('span');
        var cents = boxCents(st.idx, k);
        l2.textContent = cents != null ? '+' + money(cents) : '';
        q.append(l1, l2);
        row.appendChild(q);
      }
    }
    // One piece = only one box possible: no count question at all (Leon 25.10.2026, same rule as assets/lh-gift-box.js)
    var single = pieces <= 1;
    [g.querySelector('[data-t="qty"]'), row].forEach(function (x) { if (x.hidden !== single) x.hidden = single; });
    var hint = g.querySelector('[data-lh-box-hint]');
    var h = live ? '' : (t.boxPick || '');
    if (hint.textContent !== h) hint.textContent = h;
  }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || r.name !== 'lh_gift_option') return;
    var c = cfg();
    var st = c && boxState(c);
    if (!st) return;
    if (r.value === 'none') { boxWant = null; clickInput(st.none); track('lh_box_none', 0); }
    else if (!st.colour && st.colours[0]) { boxWant = st.colours[0].value; clickInput(st.colours[0].input); track('lh_box_with', 1); }
  });
  document.addEventListener('click', function (e) {
    var col = e.target.closest && e.target.closest('[data-lh-gift-colour]');
    var q = e.target.closest && e.target.closest('[data-lh-box-n]');
    if (!col && !q) return;
    e.preventDefault();
    var c = cfg();
    var st = c && boxState(c);
    if (!st) return;
    if (col) {
      var x = st.colours.find(function (y) { return y.value === col.getAttribute('data-lh-gift-colour'); });
      if (x) boxWant = x.value;
      if (x && x !== st.colour) clickInput(x.input);
      track('lh_box_colour', 1);
      return;
    }
    var n = Number(q.getAttribute('data-lh-box-n'));
    boxLast.n = n;
    if (!st.colour) { if (st.colours[0]) { boxWant = st.colours[0].value; clickInput(st.colours[0].input); } return; }
    boxWant = st.colour.value; // count first: "Mit" in the first colour, then the count
    clickCount(st, n);
    track('lh_box_count', n);
  });

  /* ---------- after TeeInBlue's add to cart: placeholder line (addon mode) ----------
   * LED and gift box need nothing here: they are TeeInBlue global options, TeeInBlue adds and links them itself. */
  var pend = { job: null, busy: false, timer: null };
  function setPending(job) {
    pend.job = job;
    window.__lhSetAddonPending = !!job;
    clearTimeout(pend.timer);
    if (job) pend.timer = setTimeout(function () { setPending(null); }, 15000);
  }
  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-LH-Partner': '1' }, body: JSON.stringify(body) });
  }
  async function afterAdd() {
    var job = pend.job;
    if (!job || pend.busy) return;
    pend.busy = true;
    try {
      var cart = await (await fetch('/cart.js', { headers: { 'X-LH-Partner': '1' } })).json();
      var partnered = {};
      cart.items.forEach(function (i) {
        var p = i.properties || {};
        if (p._partner_of) partnered[String(p._partner_of)] = true;
      });
      var main = cart.items.find(function (i) {   // cart.items is newest first
        var cid = i.properties && i.properties._customization_id;
        return Number(i.variant_id) === Number(job.id) && cid && !partnered[String(cid)];
      });
      if (!main) return; // main line not in the cart yet: stay pending for the next signal
      var res = await post('/cart/add.js', { items: [{ id: job.addon, quantity: main.quantity || 1, properties: { _partner_of: String(main.properties._customization_id) } }] });
      if (!res.ok) throw new Error('placeholder HTTP ' + res.status);
      track('lh_set_addon_added', job.n);
      setPending(null);
      var drawer = document.querySelector('cart-drawer');
      if (drawer && typeof drawer.renderContents === 'function') {
        setTimeout(async function () {
          try {
            var r = await fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble');
            drawer.renderContents({ sections: await r.json() });
          } catch (e) {}
        }, 300);
      }
    } catch (e) {
      console.error('[LH Set picker] could not add the placeholder line', e);
      setPending(null);
    } finally {
      pend.busy = false;
    }
  }
  document.addEventListener('click', function (e) {
    var atc = e.target.closest && e.target.closest('.tee-btn--atc');
    var c = cfg();
    if (!atc || !c) return;
    var rw = row(activeN(radios()));
    if (!rw) return;
    // never more boxes than pieces, also when the click comes right after a set change (capture phase: before TeeInBlue reads the form)
    applyCap(rw.n);
    if (c.mode === 'addon' && rw.n > 1 && rw.addon) setPending({ id: rw.id, n: rw.n, addon: rw.addon });
  }, true);
  // TeeInBlue's event is "teeinblue-event-after-cart-added" (see lh-set-switch.js); the fetch hook below is the backup
  ['teeinblue-event-after-cart-added', 'teeinblue-event-after-add-to-cart'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(afterAdd, 100); });
  });
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var h = (init && init.headers) || {};
    var own = (typeof h.get === 'function' ? h.get('X-LH-Partner') : h['X-LH-Partner']) === '1';
    var p = origFetch.apply(this, arguments);
    if (!own && pend.job && /\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (res) { if (res && res.ok) setTimeout(afterAdd, 250); }).catch(function () {});
    }
    return p;
  };

  var queued = false;
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; if (!busy) update(); }, 30); // not rAF: it never fires in a tab opened in the background
    }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('DOMContentLoaded', update);
  document.addEventListener('teeinblue-event-component-injected', function () { setTimeout(update, 50); });
  window.addEventListener('load', function () { update(); setTimeout(update, 800); setTimeout(update, 2000); });
  if (document.readyState !== 'loading') update();
})();
